import { findSelector, resource } from "data/helpers/apiv3";
import { RouteSetOverview } from "data/records";
import { fulfilled } from "lib/promiseMiddlewareHelpers";

const [api, actions] = resource(RouteSetOverview, []);

const byParent = (state, parentType, parentId) => {
  return state.apiv3.routeSetOverview.id
    .filter((x) => x.parentType === parentType && x.parentId === parentId)
    .valueSeq()
    .first();
};
const selectors = {
  ...findSelector(RouteSetOverview),
  byParent,
  byCollectionId: (state, collectionId) => byParent(state, "Collection", collectionId),
};

const reducers = {
  [fulfilled(actions.read.type)]: (state, action) => {
    const { routeSetOverview, meta } = action.payload;
    const assets = meta.assets || {};
    // munge legacy format onto the v3record
    return state.setIn(["id", routeSetOverview.id, "assets"], assets);
  },
};

const initialState = {};

export {
  api as routeSetOverviewApi,
  actions as routeSetOverviewActions,
  selectors as routeSetOverviewSelectors,
  reducers as routeSetOverviewReducers,
  initialState as routeSetOverviewInitialState,
};
